import { MetricsBar, ClaimTypeSelect } from '@enter/core';
import { mdiInformationOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import {
    ClaimVolumeCard,
    PageHeader,
    PageLayout,
    PatientCollectionsCard,
    PayerMixCard,
    PracticeSummaryCard,
} from 'components';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { RootStore } from 'stores';
import * as S from './dashboard.styles';

interface IDashboardProps {
    children?: React.ReactNode;
    rootStore: RootStore;
}

@inject('rootStore')
@observer
export class Dashboard extends React.Component<IDashboardProps> {
    public componentDidMount(): void {
        document.title = 'ENTER Platform';
    }

    public render(): React.ReactElement {
        const { dateRangeStore, metricsStore } = this.props.rootStore;
        return (
            <PageLayout>
                <PageHeader title="Overview">
                    <ClaimTypeSelect value={metricsStore.selectedClaimTypes} onChange={metricsStore.selectClaimType} />
                </PageHeader>
                <S.Info>
                    <Icon path={mdiInformationOutline} size={0.75} />
                    <span>All dates are filtered by <b>last 180 days</b> of service</span>
                </S.Info>
                <S.StyledLayoutRow>
                    <MetricsBar
                        dateRangeOption={dateRangeStore.dateRangeOption}
                        dateRange={dateRangeStore.dateRange}
                        claimTypes={metricsStore.selectedClaimTypes}
                        metrics={metricsStore.metrics}
                        datasets={metricsStore.datasets}
                        loadMetricsData={metricsStore.loadMetricsData}
                        replaceMetric={metricsStore.replaceMetric}
                    />
                </S.StyledLayoutRow>
                <S.StyledLayoutRow>
                    <ClaimVolumeCard size="large" />
                </S.StyledLayoutRow>
                <S.StyledLayoutRow>
                    <PayerMixCard />
                    <PatientCollectionsCard />
                </S.StyledLayoutRow>
                <S.StyledLayoutRow>
                    <PracticeSummaryCard size="large" />
                </S.StyledLayoutRow>
            </PageLayout>
        );
    }
}
